// ลิงก์ย้อนกลับเชิงบริบทจากหน้าเครื่องมือ → หน้าบริการรายหมวด/รายบริการ
import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import type { ServiceLink } from "@/data/tool-service-links";

interface Props {
  heading: string;
  lead?: string;
  links: ServiceLink[];
}

export default function ToolServiceBacklinks({ heading, lead, links }: Props) {
  const seen = new Set<string>();
  const unique = links.filter((l) => (seen.has(l.to) ? false : (seen.add(l.to), true)));
  if (unique.length === 0) return null;

  return (
    <section className="mt-10" data-print-hide>
      <h2 className="text-xl font-semibold">{heading}</h2>
      {lead && <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{lead}</p>}
      <div className="mt-4 grid gap-3 sm:grid-cols-2">
        {unique.map((l) => (
          <Link
            key={l.to}
            to={l.to as never}
            className="group rounded-xl border border-border bg-card p-4 transition hover:-translate-y-0.5 hover:border-primary/50 hover:shadow-sm"
            data-track-zone="tool-service-backlink"
          >
            <div className="text-sm font-semibold group-hover:text-primary">{l.label}</div>
            <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{l.desc}</p>
            <span className="mt-2 inline-flex items-center gap-1 text-[11px] font-semibold text-primary">
              ดูรายละเอียดบริการ <ArrowRight className="h-3 w-3" aria-hidden />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
